
var app = angular.module('potentiateApp', [
    'ui.router',
    'ui.bootstrap',
    'ngAnimate',
    'growlNotifications',
    'datatables',
    'chieffancypants.loadingBar',
    "highcharts-ng",
    'ngSanitize',
    'ngTagsInput',
    'ngclipboard'
]);

//This service keeps track of pending requests
app.service('httpPendingRequests', function () {
    var httpPending = [];
    this.get = function () {
        return httpPending;
    };
    this.add = function (request) {
        httpPending.push(request);
    };
    this.remove = function (requestKey) {
        $.each(httpPending, function (key, value) {
            if (requestKey == value.request_key) {
                httpPending.splice(key, 1);
                value.canceller.resolve();
            }
        });
    };
    this.cancelAll = function () {
        $.each(httpPending, function (key, value) {
            if (typeof (value.is_not_part_of_page_request) == 'undefined' || value.is_not_part_of_page_request === false) {
                value.canceller.resolve();
            }
        });
        httpPending.length = 0;
    };
    this.cancelType = function (request_type) {
        $.each(httpPending, function (key, value) {
            if (typeof (value.request_type) != 'undefined' && value.request_type == request_type) {
                httpPending.splice(key, 1);
                value.canceller.resolve();
            }
        });
    };
})

//Data Service with promise
app.factory('dataService', function ($http, $window, $location, $rootScope, $q, httpPendingRequests, $timeout) {
    var dataService =
        {
            getData: function (url, params, method, is_not_part_of_page_request, request_type, hide_loading_bar, scope) {
                //set varibale to cancel request if required
                var canceller = $q.defer();

                //get the current app URL
                var cx_current_app_url = typeof ($location.$$url) != 'undefined' ? $location.$$url : '';

                //add current app url to POST params
                if (method == 'POST') {
                    params.cx_current_app_url = cx_current_app_url;
                }

                //add this request to the pending list
                var unique_key = createGuid();
                is_not_part_of_page_request = typeof (is_not_part_of_page_request) != 'undefined' ? is_not_part_of_page_request : false;
                request_type = typeof (request_type) != 'undefined' ? request_type : null;
                httpPendingRequests.add({
                    request_key: unique_key,
                    canceller: canceller,
                    is_not_part_of_page_request: is_not_part_of_page_request,
                    request_type: request_type
                });

                //check if loading bar needs to be hidden
                hide_loading_bar = typeof (hide_loading_bar) != 'undefined' ? hide_loading_bar : false;

                //$http returns a promise
                var promise = $http({
                    url: url,
                    data: params,
                    method: method,
                    withCredentials: true,
                    headers: {"X-Requested-With": "XMLHttpRequest"},
                    timeout: canceller.promise, ignoreLoadingBar: hide_loading_bar
                }).then(function (response) {
                    if (scope != undefined && scope.httpPendingComponents != undefined && scope.httpPendingComponents[params.component_key] != undefined) {
                        delete scope.httpPendingComponents[params.component_key];
                        //Log the end time
                        scope.httpComponentEndTimeLogs[params.component_key] = new Date().getTime();
                    }

                    //if there is a redirect in response, redirect to that page
                    if (typeof (response.data.redirect) != 'undefined' && typeof (response.data.redirect_page) != 'undefined' && response.data.redirect_page != '') {
                        $window.location.href = response.data.redirect_page;
                        return false;
                    }

                    //if there is a redirect in response, redirect to that page
                    if (typeof (response.data.response_code) != 'undefined' && response.data.response_code == '403') {
                        var invalid_request_object = {};
                        invalid_request_object.request_url = url;
                        invalid_request_object.request_params = params;
                        invalid_request_object.response = response.data;

                        $rootScope.$emit('invalid_request_in_response', invalid_request_object);

                        return false;
                    }

                    // The return value gets picked up by the 'then' in the controller.
                    return response.data;
                });

                //Once a request has failed or succeeded, remove it from the pending list
                promise.finally(function () {
                    httpPendingRequests.remove(unique_key);
                    //Once all the requests are loaded
                    if (url != 'common/init_page') {
                        var pending_items = $(httpPendingRequests.get()).toArray().length;
                        /*if(pending_items == 0)
                        {
                            window.setTimeout(function () {
                                $('body').attr('data-loaded', true);
                            $('window').resize();
                            // window.callPhantom();
                            }, 2000);

                        }*/

                        if (typeof (scope) != undefined && typeof (scope.httpPendingComponents) != undefined && Object.keys(scope.httpPendingComponents).length == 0) {
                            $('body').attr('data-loaded', true);
                            var export_type = typeof ($rootScope.export_type) != 'undefined' ? $rootScope.export_type : '';
                            var login_type = typeof ($rootScope.login_type) != 'undefined' ? $rootScope.login_type : '';
                            if (export_type == 'excel' && login_type == 'robot') {
                                //wait for 3 seconds before executing the script forexport
                                $timeout(function () {
                                    var exports_details = typeof (scope.navigation[$rootScope.appState.page].exports) != 'undefined' ? scope.navigation[$rootScope.appState.page].exports : null;
                                    if (exports_details != null) {
                                        $.each(exports_details, function (key, value) {
                                            if (value.export_type == 'excel') {
                                                scope.exportPage(value, key);
                                            }
                                        });
                                    }
                                }, 3000);
                            }

                            //set the client request end time
                            var activity_log_id = typeof ($rootScope.activity_log_id) != 'undefined' ? $rootScope.activity_log_id : '';
                            if (activity_log_id) {
                                //Send a request to server
                                // console.log(activity_log_id);
                                $http({
                                    url: 'common/page_load_complete',
                                    data: {
                                        'app_state': $rootScope.appState,
                                        'activity_log_id': activity_log_id,
                                        'component_start_times': scope.httpComponentStartTimeLogs,
                                        'component_end_times': scope.httpComponentEndTimeLogs
                                    },
                                    method: 'POST',
                                    withCredentials: true,
                                    headers: {"X-Requested-With": "XMLHttpRequest"},
                                    // timeout: canceller.promise,
                                    ignoreLoadingBar: hide_loading_bar
                                }).then(function (response) {
                                        if (typeof (response.data) != 'undefined') {
                                            // console.log('data load complete ');
                                        }
                                    }
                                );
                            }
                        }
                    }

                });

                // Return the promise to the controller
                return promise;
            },
            getDataWithFileUpload: function (url, params, method, files, is_not_part_of_page_request, request_type, hide_loading_bar, scope) {
                //set varibale to cancel request if required
                var canceller = $q.defer();

                //get the current app URL
                var cx_current_app_url = typeof ($location.$$url) != 'undefined' ? $location.$$url : '';

                //add current app url to POST params
                if (method == 'POST') {
                    params.cx_current_app_url = cx_current_app_url;
                }

                //add this request to the pending list
                var unique_key = createGuid();
                is_not_part_of_page_request = typeof (is_not_part_of_page_request) != 'undefined' ? is_not_part_of_page_request : false;
                request_type = typeof (request_type) != 'undefined' ? request_type : null;
                httpPendingRequests.add({
                    request_key: unique_key,
                    canceller: canceller,
                    is_not_part_of_page_request: is_not_part_of_page_request,
                    request_type: request_type
                });

                //check if loading bar needs to be hidden
                hide_loading_bar = typeof (hide_loading_bar) != 'undefined' ? hide_loading_bar : false;

                var fd = new FormData();

                angular.forEach(params, function (value, key) {
                    if (angular.isObject(value)) {
                        fd.append(key, angular.toJson(value));
                    } else {
                        fd.append(key, value);
                    }
                });

                angular.forEach(files, function (file) {
                    fd.append('file[]', file);
                });

                //$http returns a promise
                var promise = $http({
                    url: url,
                    data: fd,
                    method: method,
                    withCredentials: true,
                    headers: {'Content-Type': undefined},
                    timeout: canceller.promise, ignoreLoadingBar: hide_loading_bar
                }).then(function (response) {
                    if (scope != undefined && scope.httpPendingComponents != undefined && scope.httpPendingComponents[params.component_key] != undefined) {
                        delete scope.httpPendingComponents[params.component_key];
                    }

                    //if there is a redirect in response, redirect to that page
                    if (typeof (response.data.redirect) != 'undefined' && typeof (response.data.redirect_page) != 'undefined' && response.data.redirect_page != '') {
                        $window.location.href = response.data.redirect_page;
                        return false;
                    }

                    //if there is a redirect in response, redirect to that page
                    if (typeof (response.data.response_code) != 'undefined' && response.data.response_code == '403') {
                        var invalid_request_object = {};
                        invalid_request_object.request_url = url;
                        invalid_request_object.request_params = params;
                        invalid_request_object.response = response.data;

                        $rootScope.$emit('invalid_request_in_response', invalid_request_object);

                        return false;
                    }

                    // The return value gets picked up by the 'then' in the controller.
                    return response.data;
                });

                //Once a request has failed or succeeded, remove it from the pending list
                promise.finally(function () {
                    httpPendingRequests.remove(unique_key);
                    //Once all the requests are loaded
                    if (url != 'common/init_page') {
                        var pending_items = $(httpPendingRequests.get()).toArray().length;
                        /*if(pending_items == 0)
                        {
                            window.setTimeout(function () {
                                $('body').attr('data-loaded', true);
                            $('window').resize();
                            // window.callPhantom();
                            }, 2000);

                        }*/

                        if (typeof (scope) != undefined && typeof (scope.httpPendingComponents) != undefined && Object.keys(scope.httpPendingComponents).length == 0) {
                            $('body').attr('data-loaded', true);
                        }
                    }

                });

                // Return the promise to the controller
                return promise;
            }
        };
    return dataService;
});

//Get init data for pages
app.factory('pageConfig', function (dataService, $q, $rootScope, appActivity) {
    var pageConfig =
        {
            getPageConfig: function () {
                var deferred = $q.defer();

                //hide error container before any page load
                $('#runTimeError').hide();

                dataService.getData('common/init_page', {'app_state': $rootScope.appState}, 'POST')
                    .then(function (response) {
                            if (typeof (response.data) != 'undefined') {
                                //Set the activity log id if found
                                if (typeof (response.data['activity_log_id']) != 'undefined') {
                                    var activity_log_id = response.data['activity_log_id'];
                                    $rootScope.activity_log_id = activity_log_id;
                                }

                                if (typeof (response.data['login_messages']) != 'undefined' && Object.keys(response.data['login_messages'])) {
                                    var login_messages = response.data['login_messages'];
                                    var message_id = '';
                                    var message = {};
                                    var login_message_html = '<div class="modal-dialog">' +
                                        '<div class="modal-content">' +
                                        '';
                                    var wdw_title = 'Messages';

                                    var login_message_content_html = '';

                                    $.each(login_messages, function (key, value) {
                                        if (typeof ($rootScope['login_message_show_' + value.id + '_count']) != 'undefined' && typeof (value.show_each_page_visit) != 'undefined' && value.show_each_page_visit == 0) {
                                            return true;
                                        }

                                        if (value.window_title != '') {
                                            wdw_title = value.window_title;
                                        }

                                        login_message_content_html += '<div class="modal-header"><button style="display:none" type="button" class="close" data-dismiss="modal">&times;</button><b>' + wdw_title + '</b></div>';
                                        login_message_content_html += '<div class="modal-body">';
                                        login_message_content_html += '<div id="content_section">';
                                        login_message_content_html += '<p><b>' + value.message_title + '</b></p>';
                                        login_message_content_html += '<p>' + value.message + '</p>';
                                        login_message_content_html += '</div></div>';
                                        message_id += value.id + ',';

                                        $rootScope['login_message_show_' + value.id + '_count'] = 1;
                                    });

                                    if (message_id != '') {
                                        message.message_ids = message_id;
                                    }

                                    login_message_html += login_message_content_html;
                                    login_message_html += '<div class="modal-footer help-block report-login-message"><a class="btn btn-sm btn-primary" href="javascript:void(0);">Close</a></div>';
                                    login_message_html += '</div></div>';

                                    if (login_message_content_html != '') {
                                        $('#loginMessage').modal('hide');// if you don't want to lose the reference to previous backdrop
                                        $('#loginMessage').data('bs.modal', null); // this clears the BS modal data

                                        $('#loginMessage').html(login_message_html);

                                        $('#loginMessage .report-login-message a:eq(0)').click(function () {
                                            appActivity.updateLoginMessageStatus(message, 'loginMessage');
                                        })
                                        // $('#runTimeError').show();
                                        $('#loginMessage').modal({
                                            backdrop: 'static',
                                            keyboard: true,
                                            show: true
                                        });
                                    }
                                }
                                deferred.resolve(response.data);
                            }
                        }
                    );
                return deferred.promise;
            }
        }

    return pageConfig;
});

app.factory('sidebarConfig', function (dataService, $q, $rootScope) {
    var sidebarConfig =
        {
            getSidebarConfig: function () {
                var deferred = $q.defer();

                //hide error container before any page load
                $('#runTimeError').hide();

                var newState = angular.copy($rootScope.appState);
                //modify the page
                newState.page = 'right_sidebar';
                //todo: modify the filters
                newState.page_filters = {};

                dataService.getData('common/init_sidebar', {'app_state': newState}, 'POST')
                    .then(function (response) {
                            if (typeof (response.data) != 'undefined') {
                                // $rootScope.previousSidebar = response.data;
                                deferred.resolve(response.data);
                            }
                        }
                    );
                return deferred.promise;
            }
        }

    return sidebarConfig;
});

//Page handler
app.factory('pageHandler', function (dataService, $q, DTOptionsBuilder, DTColumnBuilder, $http, $rootScope, $timeout, $compile, httpPendingRequests) {
    var pageHandler =
        {
            //show loading image for components
            showLoading: function (currentPageConfig, scope) {
                //TODO loop through the components, look for loading conf and show loading image
            },

            //Initialise views based on survey key
            initViews: function (currentPageConfig, scope) {
                if (typeof currentPageConfig.html_options != 'undefined') {
                    scope['html_options'] = currentPageConfig.html_options;
                }
                scope.submenuView = (typeof (scope.appState.submenu_key) != 'undefined') ? angular.copy(scope.appState.submenu_key) : '';
                scope.newPage = angular.copy($rootScope.newPage);

                //unset newpage
                $rootScope.newPage = false;
            },

            //initialise components
            initComponents: function (currentPageConfig, scope) {
                scope.httpPendingComponents = {};
                scope.httpComponentStartTimeLogs = {};
                scope.httpComponentEndTimeLogs = {};
                if (typeof currentPageConfig.components != 'undefined') {
                    function recursiveIteration(object) {
                        for (var property in object) {
                            if (object.hasOwnProperty(property)) {
                                if (typeof object[property] == "object") {
                                    object[property] = recursiveIteration(object[property]);
                                } else {
                                    //found a property which is not an object, check if the property is a function
                                    if (typeof (object[property]) == 'string' && object[property].indexOf("function(") >= 0) {
                                        var temp_func = object[property];
                                        object[property] = eval('(' + temp_func + ')');
                                    } else {
                                        object[property] = object[property];
                                    }
                                }
                            }
                        }

                        return object;
                    }

                    $.each(currentPageConfig.components, function (componentKey, component) {
                        currentPageConfig.components[componentKey].init_config = recursiveIteration(component.init_config);

                        //check if is not accessible, then skip
                        if (typeof (component.not_accessible) != 'undefined' && component.not_accessible == true) {
                            scope[componentKey] = component;
                            return true;
                        }

                        if (component.component_type == 'dbtable') {
                            var pageComponent = new dbTable();
                            pageComponent.init(scope, componentKey, component, DTOptionsBuilder, DTColumnBuilder, $http);
                        } else if (component.component_type == 'comparison_chart') {
                            var pageComponent = new comparison_chart();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'simple_chart') {
                            var pageComponent = new simple_chart();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'gauge_chart') {
                            var pageComponent = new gauge_chart();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'donut_chart') {
                            var pageComponent = new donut_chart();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'push_report_chart') {
                            var pageComponent = new push_report_chart();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'simpletable') {
                            var pageComponent = new simpleTable();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'generic_table') {
                            var pageComponent = new generic_table();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'data_block') {
                            var pageComponent = new data_block();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'reason_code') {
                            var pageComponent = new reason_code();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'trend') {
                            var pageComponent = new trend();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'diagnostics') {
                            var pageComponent = new diagnostics();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'push_report_priority_areas') {
                            var pageComponent = new push_report_priority_areas();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'importance_ranking') {
                            var pageComponent = new importance_ranking();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'live_comments') {
                            var pageComponent = new live_comments();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'search_widget') {
                            var pageComponent = new search_widget();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'solid_gauge') {
                            var pageComponent = new solid_gauge();
                            pageComponent.init(scope, componentKey, component);
                        } else if (component.component_type == 'crosstab_chart') {
                            var pageComponent = new crosstab_chart();
                            pageComponent.init(scope, componentKey, component);
                        }

                        scope.httpPendingComponents[componentKey] = componentKey;
                        scope.httpComponentStartTimeLogs[componentKey] = new Date().getTime();

                    });
                }

            },

            initFilters: function (currentPageConfig, scope) {
                var returnStatus = true;

                if (typeof currentPageConfig.filters != 'undefined') {
                    $.each(currentPageConfig.filters, function (filterKey, filter) {
                        //check if is not accessible, then skip
                        if (typeof (filter.not_accessible) != 'undefined' && filter.not_accessible == true) {
                            //check if the filter has to be available in entire app scope
                            if (typeof (filter.available_in_app_scope) != 'undefined' && filter.available_in_app_scope === true) {
                                //do nothing, can update at the end
                            } else {
                                scope[filterKey] = filter;
                            }

                            return true;
                        }

                        //if value exists in appState, replace the value
                        if (typeof (scope.appState.page_filters[filterKey]) != 'undefined') {
                            //check if the selected option is available
                            var options_field = typeof (filter.options_field) != 'undefined' ? filter.options_field : null;
                            if (options_field) {
                                var available_options = typeof (filter[options_field]) != 'undefined' ? filter[options_field] : null;
                                if (!jQuery.isEmptyObject(available_options)) {
                                    var currentSelection = typeof (scope.appState.page_filters[filterKey]) != 'undefined' ? angular.copy(scope.appState.page_filters[filterKey]) : null;

                                    //check whether multiple filter values need to be selected
                                    if (typeof (filter.select_mode) != 'undefined' && filter.select_mode == 'multiple') {
                                        var selected_filters = currentSelection.split(',');
                                        var all_selections = [];

                                        //validate each of the selected values for the filter if they are present in the options defined for that filter
                                        $.each(selected_filters, function (optionKey, optionValue) {
                                            if (typeof (available_options[optionValue]) != 'undefined') {
                                                all_selections.push(optionValue);
                                            }
                                        });

                                        $.each(available_options, function (OptKey, optVal) {
                                            if (typeof (optVal.default_select) != 'undefined' && optVal.default_select === true) {
                                                if (typeof (scope.appState.unchecked_values) == 'undefined') {
                                                    if (jQuery.inArray(optVal.value, all_selections) === -1) {
                                                        all_selections.push(optVal.value);
                                                    }
                                                }
                                            }
                                        });

                                        var new_filter_value = all_selections.join(',');

                                        //If the first item needs to be selected
                                        if (typeof (filter['first_item_checked']) != 'undefined' && filter['first_item_checked'] == true) {
                                            var firstKey = '';
                                            for (var i in available_options) {
                                                if (available_options.hasOwnProperty(i)) {
                                                    firstKey = i;
                                                    break;
                                                }
                                            }

                                            filter.default_value = firstKey;
                                            //If the filter value is empty, reset it
                                            if (new_filter_value == '') {
                                                //reset the new filter value to default
                                                new_filter_value = firstKey;
                                            }
                                        }

                                        if (currentSelection && currentSelection != new_filter_value) {
                                            scope.appState.page_filters[filterKey] = new_filter_value;
                                            returnStatus = false;
                                        }

                                    } else {
                                        //if not found in available_options, reset to default in appState which will trigger redirection
                                        if (currentSelection && currentSelection != '' && typeof (available_options[currentSelection]) == 'undefined') {
                                            scope.appState.page_filters[filterKey] = filter.selected_value;
                                            returnStatus = false;
                                        }
                                    }

                                }
                            }

                            //set current value in appState as selected
                            filter.selected_value = scope.appState.page_filters[filterKey];
                        }

                        //check if the filter has to be available in entire app scope
                        if (typeof (filter.available_in_app_scope) != 'undefined' && filter.available_in_app_scope === true) {
                            currentPageConfig.filters[filterKey] = filter;
                        } else {
                            scope[filterKey] = filter;
                        }
                    });

                    //update app scope page filters
                    if (!jQuery.isEmptyObject(scope.app_scope_page_filters)) {
                        $.each(scope.app_scope_page_filters, function (filterKey, filter) {
                            var current_app_scope_page_filter = {'filter_key': filterKey, 'filter_value': filter};

                            if (typeof (currentPageConfig.filters[filterKey]) != 'undefined') {
                                current_app_scope_page_filter.filter_value = currentPageConfig.filters[filterKey];
                            } else {
                                //hide app scope page filters which are not available for this view
                                current_app_scope_page_filter.filter_value.not_accessible = true;

                                //if persistent value is true, store the current value for future use
                                if (typeof (filter.persistent_value) != 'undefined' && filter.persistent_value == true &&
                                    (typeof (scope.app_scope_page_filters[filterKey].last_selection) == 'undefined' || scope.app_scope_page_filters[filterKey].last_selection === null)) {
                                    scope.app_scope_page_filters[filterKey].last_selection = typeof (scope.$parent[filterKey]) != 'undefined' && typeof (scope.$parent[filterKey].selected_value) != 'undefined' ?
                                        scope.$parent[filterKey].selected_value : null;
                                }
                            }
                            scope.$parent[filterKey] = angular.copy(current_app_scope_page_filter.filter_value);
                            scope.$emit('appScopefilterUpdate', current_app_scope_page_filter);
                        });
                    }
                }

                if (returnStatus === false) {
                    $timeout(function () {
                        scope.$apply();
                    }, 10);
                }
                return returnStatus;

            },

            requestDataForComponents: function (currentPageConfig, scope) {
                //TODO loop through the components, look for fetch_data and request data
                if (typeof currentPageConfig.components != 'undefined') {
                    var group_components = {};
                    var request_url = "";
                    var sub_domains_available = typeof scope.sub_domain_map !== 'undefined' ? scope.sub_domain_map : null;
                    var domain_pointer = 0;

                    $.each(currentPageConfig.components, function (componentKey, component) {
                        //check if is not accessible, then skip
                        if (typeof (component.not_accessible) != 'undefined' && component.not_accessible == true) {
                            return true;
                        }

                        if (typeof (component.fetch_data) != 'undefined' && component.fetch_data == 'self') {
                            //set loading flag
                            if (typeof (scope[componentKey]) != 'undefined') {
                                scope[componentKey].dataLoading = true;
                            }

                            var pageState = angular.copy(scope.appState);
                            if (typeof (pageState.page_filters) != 'undefined') {
                                $.each(pageState.page_filters, function (filter_key, filter_value) {
                                    if (typeof (scope[filter_key]) != 'undefined') {
                                        if (typeof (scope[filter_key].not_accessible) != 'undefined' && scope[filter_key].not_accessible == true) {
                                            delete pageState.page_filters[filter_key];
                                        }
                                    }
                                })
                            }

                            var sub_domain_url = typeof sub_domains_available[domain_pointer] != 'undefined' ? sub_domains_available[domain_pointer] : '';
                            var target_url = sub_domain_url + component.config.url;

                            //fetch the component's data
                            dataService.getData(target_url, {
                                'app_state': pageState,
                                'filters': currentPageConfig.filters,
                                'component_key': componentKey
                            }, 'POST', false, null, false, scope)
                                .then(function (response) {

                                    //unset loading flag
                                    if (typeof (scope[componentKey]) != 'undefined' && typeof (scope[componentKey].dataLoading) != 'undefined') {
                                        scope[componentKey].dataLoading = false;
                                    }

                                    if (response.data) {
                                        //Pass the response data to its particular component type for updation
                                        $.each(response.data, function (resultComponentKey, resultComponentVal) {
                                            if (component.component_type == 'comparison_chart') {
                                                var pageComponent = new comparison_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            }
                                            if (component.component_type == 'simple_chart') {
                                                var pageComponent = new simple_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'gauge_chart') {
                                                var pageComponent = new gauge_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'donut_chart') {
                                                var pageComponent = new donut_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'push_report_chart') {
                                                var pageComponent = new push_report_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'simpletable') {
                                                var pageComponent = new simpleTable();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'generic_table') {
                                                var pageComponent = new generic_table();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'data_block') {
                                                var pageComponent = new data_block();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'reason_code') {
                                                var pageComponent = new reason_code();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'trend') {
                                                var pageComponent = new trend();
                                                pageComponent.update(scope, resultComponentKey, resultComponentVal);
                                            } else if (component.component_type == 'diagnostics') {
                                                var pageComponent = new diagnostics();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'push_report_priority_areas') {
                                                var pageComponent = new push_report_priority_areas();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'importance_ranking') {
                                                var pageComponent = new importance_ranking();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'live_comments') {
                                                var pageComponent = new live_comments();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'solid_gauge') {
                                                var pageComponent = new solid_gauge();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            } else if (component.component_type == 'crosstab_chart') {
                                                var pageComponent = new crosstab_chart();
                                                pageComponent.update(scope, componentKey, resultComponentVal);
                                            }
                                        });
                                    }

                                });
                        }

                        domain_pointer = domain_pointer >= sub_domains_available.length ? 0 : domain_pointer + 1;

                    });
                }
            },

            initPageExports: function (currentPageConfig, scope) {
                //Listen for export event from main controller, bind the listener to the page controller scope
                if (typeof (currentPageConfig.components) != 'undefined' && !jQuery.isEmptyObject(currentPageConfig.components)) {
                    scope.$on('exportPageEvent', function (event, params) {

                        scope.startExport(params, scope, currentPageConfig);
                    });
                }
            }

        };

    return pageHandler;
});

//appService : define global functions here
app.factory('appService', function (dataService, $q) {
    var appService =
        {
            //Get default app filters, page params and page/submenu filters
            getPageParamsFilters: function (page, scope, currentParams, defaultSubmenuKey) {

                //validate if this a valid page
                if (typeof (scope.navigation[page]) == 'undefined') {
                    return [];
                }

                //Step 1. find app filters
                var pageParamsFilters = [];
                $.each(scope.filters, function (key, value) {
                    var valueObject = {};
                    valueObject[key] = '';
                    pageParamsFilters.push(valueObject);

                    //check if value has one more dimension
                    if (typeof (value.value) != 'undefined') {
                        var extra_dimension = false;
                        $.each(value.value, function (tKey, tValue) {
                            if (typeof (tValue.value) != 'undefined') {
                                extra_dimension = true;
                                return false;
                            }
                        });

                        if (extra_dimension === true) {
                            var valueObject = {};
                            valueObject[key + '_value'] = '';
                            pageParamsFilters.push(valueObject);
                        }
                    }

                    if (typeof (value.superset) != 'undefined') {
                        var valueObject = {};
                        valueObject[key + '_superset_value'] = '';
                        pageParamsFilters.push(valueObject);
                    }
                });

                //Step 2. find submenu_key
                var submenu_key = '';
                if (typeof (scope.navigation[page].submenu) != 'undefined') {
                    //get all submenu keys
                    var submenu_keys = [];
                    $.each(scope.navigation[page].submenu, function (index, submenu) {
                        if (typeof (submenu.key) != 'undefined') {
                            submenu_keys.push(submenu.key);
                        }
                    });

                    //loop through current params to look for a submenu key
                    $.each(currentParams, function (key, value) {
                        if (jQuery.inArray(value, submenu_keys) != -1) {
                            submenu_key = value;
                            return false;
                        }

                    });

                    //if submenu key not found in CurrentParams(browser URL), then check defaultSubmenuKey exists(populated from default_filters in angularconfig.php)
                    //This will make sure that if a default submenu is set for the user role, it works as expected.
                    if (submenu_key == '' && submenu_keys.length > 0 && jQuery.isEmptyObject(currentParams) && typeof (defaultSubmenuKey) != 'undefined' && defaultSubmenuKey !== '') {
                        if (jQuery.inArray(defaultSubmenuKey, submenu_keys) != -1) {
                            submenu_key = defaultSubmenuKey;
                        }
                    }


                    //if not found select the first submenu item key
                    if (submenu_key == '' && submenu_keys.length > 0) {
                        submenu_key = submenu_keys[0];
                    }
                } else {
                    //check if submenu key exist in the params
                    if (typeof currentParams['selectedKey'] != 'undefined') {
                        submenu_key = typeof currentParams[currentParams['selectedKey']] != 'undefined' ? currentParams[currentParams['selectedKey']] : '';
                    }

                    //if no survey key, check if it is available in the params for the default page
                    if (submenu_key == '') {
                        submenu_key = typeof scope.navigation[page] != 'undefined' &&
                        typeof scope.navigation[page]['params'] != 'undefined' &&
                        typeof scope.navigation[page]['params']['submenu_key'] != 'undefined'
                            ? scope.navigation[page]['params']['submenu_key'] : '';
                    }
                }

                //Step 3. find page params
                //@exception: If the page doesn't have a submenu but has a dynamic submenu defined as surveys, get params from scope.page_params[page]
                var paramsObject = (submenu_key != '') && typeof scope.page_params[page][submenu_key] != 'undefined' ? scope.page_params[page][submenu_key] : scope.page_params[page];
                $.each(paramsObject, function (key, value) {
                    var valueObject = {};
                    valueObject[key] = value;
                    pageParamsFilters.push(valueObject);
                });

                //Step 4.Find page filters
                var filters = [];
                if (typeof (scope.page_filters[page]) != 'undefined') {
                    var all_page_filters = angular.copy(scope.page_filters[page]);
                    if (submenu_key != '') {
                        if (typeof (all_page_filters[submenu_key]) != 'undefined') {
                            filters = all_page_filters[submenu_key];
                        }
                    } else {
                        filters = all_page_filters;
                    }
                }

                //Step 5. initialise values for page filters
                var page_filter = {};
                $.each(filters, function (key, value) {
                    //check if this is an app scope filter
                    var valueFound = false;
                    if (typeof (value.available_in_app_scope) != 'undefined' && value.available_in_app_scope === true) {
                        //check if a value is already selected and available in appState
                        if (typeof (scope.appState.page_filters) != 'undefined' && typeof (scope.appState.page_filters[key]) != 'undefined') {
                            page_filter[key] = scope.appState.page_filters[key];
                            valueFound = true;
                        }

                        //check if a value is already selected and available in URL (first load)
                        if (valueFound === false && typeof (currentParams[key]) != 'undefined') {
                            page_filter[key] = currentParams[key];
                            valueFound = true;
                        }

                        //check if the last selection need to be restored for app scope filters
                        if (valueFound === false && typeof (value.persistent_value) != 'undefined' && value.persistent_value == true
                            && typeof (scope.app_scope_page_filters[key].last_selection) != 'undefined' && scope.app_scope_page_filters[key].last_selection !== null) {
                            page_filter[key] = angular.copy(scope.app_scope_page_filters[key].last_selection);
                            scope.app_scope_page_filters[key].last_selection = null; //reset value
                            valueFound = true;
                        }
                    }

                    if (valueFound === false) {
                        page_filter[key] = value.selected_value;
                    }

                });

                var valueObject = {};
                valueObject.page_filters = page_filter;
                pageParamsFilters.push(valueObject);


                return pageParamsFilters;
            },

            //add default app params, page filters and page params to state, overwrite values from currentParams array
            addParamsFiltersToState: function (pageParamsFilters, currentParams, scope) {
                var appState = {};
                var appFilterKeys = [];
                var validatedKeys = [];
                var appServiceObj = this;
                $.each(scope.filters, function (key, value) {
                    appFilterKeys.push(key);
                });

                $.each(pageParamsFilters, function (key, value) {
                    $.each(value, function (paramKey, paramValue) {
                        //skip keys
                        if (paramKey == 'selectedKey' || $.inArray(paramKey, validatedKeys) != -1) {
                            return true;
                        }

                        if (paramKey == 'page_filters') {
                            appState.page_filters = {};
                            $.each(paramValue, function (filterKey, filterValue) {
                                //if value exists in URL, use that value
                                appState.page_filters[filterKey] = (typeof (currentParams[filterKey]) != 'undefined') ? currentParams[filterKey] : filterValue;

                            });
                        } else {
                            //if value exists in URL, use that value after validating
                            var newValue = (typeof (currentParams[paramKey]) != 'undefined') ? currentParams[paramKey] : null;
                            if (newValue !== null) {
                                //validate newValue
                                if (newValue != '' && $.inArray(paramKey, appFilterKeys) != -1 && paramKey != 'custom_filter') {
                                    //if not valid, use default
                                    if (typeof (scope.filters[paramKey]) == 'undefined' || typeof (scope.filters[paramKey].value) == 'undefined' || typeof (scope.filters[paramKey].value[newValue]) == 'undefined') {
                                        newValue = paramValue;
                                    }
                                }

                                //check if its a valid page
                                if (newValue != '' && paramKey == 'page') {
                                    if (typeof (scope.navigation[newValue]) == 'undefined') {
                                        newValue = paramValue;
                                    }
                                }
                            } else {
                                newValue = paramValue;
                            }

                            appState[paramKey] = newValue;

                            //mark paramKey as validated
                            validatedKeys.push(paramKey);

                            //look for deeper param values (e.g. admin_site_value & admin_site_superset_value)
                            if (appState[paramKey] != '' && $.inArray(paramKey, appFilterKeys) != -1) {
                                //look for 1 level deep (e.g. admin_site_value)
                                var deepLevelParamKay = paramKey + '_value';
                                var deepLevelParamValue = (typeof (currentParams[deepLevelParamKay]) != 'undefined') ? currentParams[deepLevelParamKay] : null;

                                if (deepLevelParamValue != null) //if not null, validate it
                                {
                                    var validatedValue = appServiceObj.validateParamValueWithParent(pageParamsFilters, scope, deepLevelParamKay, deepLevelParamValue, paramKey, appState, false);
                                    if (validatedValue !== null) {
                                        appState[deepLevelParamKay] = validatedValue;
                                        validatedKeys.push(deepLevelParamKay);
                                    }

                                }

                                //look for 2 level deep (e.g. admin_site_superset_value)
                                var deepLevelParamKay = paramKey + '_superset_value';
                                var deepLevelParamValue = (typeof (currentParams[deepLevelParamKay]) != 'undefined') ? currentParams[deepLevelParamKay] : null;

                                if (deepLevelParamValue != null) //if not null, validate it
                                {
                                    var validatedValue = appServiceObj.validateParamValueWithParent(pageParamsFilters, scope, deepLevelParamKay, deepLevelParamValue, paramKey, appState, true);
                                    if (validatedValue !== null) {
                                        appState[deepLevelParamKay] = validatedValue;
                                        validatedKeys.push(deepLevelParamKay);
                                    }

                                }

                            }
                        }
                    });
                });

                return appState;
            },

            validateParamValueWithParent: function (pageParamsFilters, scope, deepLevelParamKay, deepLevelParamValue, paramKey, appState, isSuperset) {
                var validatedValue = null;
                var searchkeyFound = false;

                $.each(pageParamsFilters, function (pageK, pageV) {
                    $.each(pageV, function (pKey, pValue) {
                        if (pKey == deepLevelParamKay) //if key is found in pageParamsFilters
                        {
                            var lookupList = (typeof (scope.filters[paramKey]) != 'undefined' && typeof (scope.filters[paramKey].value) != 'undefined') ? scope.filters[paramKey].value : {};
                            var subsetKey = null;

                            if (typeof (isSuperset) != 'undefined' && isSuperset == true) {
                                subsetKey = 'superset'; //parent value
                            } else {
                                subsetKey = appState[paramKey]; //parent value
                            }

                            if (!jQuery.isEmptyObject(lookupList)) //if parent set available
                            {
                                var keyFound = false;

                                if (subsetKey != null && typeof (lookupList[subsetKey]) != 'undefined' && typeof (lookupList[subsetKey].value) != 'undefined') {
                                    $.each(lookupList[subsetKey].value, function (filterKey, filterValue) {
                                        if (filterValue.id == deepLevelParamValue) {
                                            keyFound = true;
                                            return false;
                                        }
                                    });

                                    //if not valid, use the first item from parent set
                                    if (keyFound === false) {
                                        $.each(lookupList[subsetKey].value, function (filterKey, filterValue) {
                                            validatedValue = filterValue.id;

                                            return false; //break;
                                        });
                                    } else //valid, set the param value
                                    {
                                        validatedValue = deepLevelParamValue;
                                    }
                                } else {
                                    validatedValue = pValue;
                                }

                            } else {
                                validatedValue = pValue;
                            }

                            searchkeyFound = true;
                            return false;//break
                        }
                    });

                    if (searchkeyFound === true) {
                        return false;//break
                    }
                });

                return validatedValue;
            }
        }

    return appService;
});

app.factory('appActivity', function ($http) {
    var appActivity =
        {
            logActivity: function (logData) {
                $http({
                    url: 'log',
                    data: logData,
                    method: 'POST',
                    headers: {"X-Requested-With": "XMLHttpRequest"}
                }).then(function (response) {
                    //do nothing
                });
            },
            reportError: function (logData, reportUiElement) {
                $http({
                    url: 'log/report_error',
                    data: logData,
                    method: 'POST',
                    headers: {"X-Requested-With": "XMLHttpRequest"}
                }).then(function (response) {
                    if (typeof (reportUiElement) != 'undefined') {
                        $(reportUiElement).html('Thank You!! The issue is reported.');
                    }
                });
            },
            updateLoginMessageStatus: function (MessageIds, elemt) {
                $http({
                    url: 'common/update_login_message_used_count',
                    data: MessageIds,
                    method: 'POST',
                    headers: {"X-Requested-With": "XMLHttpRequest"}
                }).then(function (response) {

                });
                $("#" + elemt + " .close").click()
            },
        }
    return appActivity;
});

//For sorting response in ng-repeat
app.filter('orderObjectBy', function () {
    return function (input, attribute) {
        if (!angular.isObject(input)) return input;

        var array = [];
        for (var objectKey in input) {
            //add objectKey as a property
            input[objectKey].objectKey = objectKey;
            array.push(input[objectKey]);
        }

        array.sort(function (a, b) {
            a = parseInt(a[attribute]);
            b = parseInt(b[attribute]);
            return a - b;
        });
        return array;
    }
});

app.filter('nl2br', function ($sce) {
    return function (msg, is_xhtml) {
        var is_xhtml = is_xhtml || true;
        var breakTag = (is_xhtml) ? '<br />' : '<br>';
        var msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return $sce.trustAsHtml(msg);
    }
});

app.factory('RecursionHelper', ['$compile', function ($compile) {
    return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function (element, link) {
            // Normalize the link parameter
            if (angular.isFunction(link)) {
                link = {post: link};
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function (scope, element) {
                    // Compile the contents
                    if (!compiledContents) {
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function (clone) {
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if (link && link.post) {
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);

app.service('anchorSmoothScroll', function () {

    this.scrollTo = function (eID) {

        // This scrolling function 
        // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

        var startY = currentYPosition();
        var stopY = elmYPosition(eID);

        var distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY);
            return;
        }
        var speed = Math.round(distance / 100);
        if (speed >= 20) speed = 20;
        var step = Math.round(distance / 25);
        var leapY = stopY > startY ? startY + step : startY - step;
        var timer = 0;
        if (stopY > startY) {
            for (var i = startY; i < stopY; i += step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY += step;
                if (leapY > stopY) leapY = stopY;
                timer++;
            }
            return;
        }
        for (var i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }

        function currentYPosition() {
            // Firefox, Chrome, Opera, Safari
            if (self.pageYOffset) return self.pageYOffset;
            // Internet Explorer 6 - standards mode
            if (document.documentElement && document.documentElement.scrollTop)
                return document.documentElement.scrollTop;
            // Internet Explorer 6, 7 and 8
            if (document.body.scrollTop) return document.body.scrollTop;
            return 0;
        }

        function elmYPosition(eID) {
            var elm = document.getElementById(eID);
            var y = elm.offsetTop;
            var node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
                node = node.offsetParent;
                y += node.offsetTop;
            }
            return y;
        }

    };

});

app.run(function ($rootScope, $location) {
    $rootScope.$on("$locationChangeStart", function (event, next, current) {
        if (typeof ($rootScope.google_analytics_tracking_code) != 'undefined' && $rootScope.google_analytics_tracking_code != '') {
            var submenu_label = $rootScope.appState.submenu_key;
            if (typeof ($rootScope.submenu_labels) != 'undefined' && typeof ($rootScope.submenu_labels[$rootScope.appState.submenu_key]) != 'undefined') {
                submenu_label = $rootScope.submenu_labels[$rootScope.appState.submenu_key].toLowerCase();
            }

            gtag('config', $rootScope.google_analytics_tracking_code, {
                'page_title': $rootScope.appState.page + '_' + submenu_label,
                'page_path': '/' + $rootScope.appState.page + '/' + submenu_label
            });
        }
    });
});
